function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Platform } from 'react-native';
export const DEFAULT_CONFIG = {
  cycles: 1,
  useNativeDriver: Platform.OS !== 'web'
};
/**
 * @property {number} cycles - number of animation cycles. -1 for infinite
 */

export class Animation {
  constructor(config) {
    _defineProperty(this, "animation", void 0);

    _defineProperty(this, "counter", 0);

    _defineProperty(this, "endCallback", void 0);

    _defineProperty(this, "running", false);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "onAnimationEnd", result => {
      this.counter += 1;

      if (this.counter === this.config.cycles) {
        this.stop();
      }

      if (this.running) {
        this.start(this.endCallback);
      }

      if (!this.running) {
        this.counter = 0;
        this.endCallback && this.endCallback(result);
        this.endCallback = null;
      }
    });

    this.config = _objectSpread(_objectSpread({}, DEFAULT_CONFIG), config);
  }

  start(callback) {
    this.endCallback = callback;
    this.running = true;
    this.animation.start(this.onAnimationEnd);
  }

  stop() {
    this.running = false;
    this.animation.stop();
  }

  release() {
    this.stop();
  }

}